import {getMethod} from '~/api'

async function get(request) {
    return await getMethod('/api/hotelLocationDictionaryInfo', request)
}

export {get}
